//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../GeometricUtilities/GeometricUtilities.CurveOptions.js";
import "../no/Section.js";
import "../no/GeometricUtilities.js";
import "../no/Section.js";
let d=[[[0,"AngleTolerance",1,0],[1,"CurveOptions",0,"GeometricUtilities.CurveOptions",0],[0,"DistanceTolerance",1,0],[0,"MaximumDegree",1,0],[0,"MaximumSegments",1,0],[0,"OutputCurveType",1,0],[1,"Section",0,"Section",0]],[],[]];
SPLM.Features.JoinCurvesBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.JoinCurvesBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.JoinCurvesBuilder.OutputCurve = Object.freeze({
    "General" : "General", "Cubic" : "Cubic", "Quintic" : "Quintic", "Advanced" : "Advanced"});

export default SPLM;